import { render, staticRenderFns } from "./group_users_table.vue?vue&type=template&id=5527eaf5&"
import script from "./group_users_table.vue?vue&type=script&lang=js&"
export * from "./group_users_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports